import { ActionNode, addEventListener, dispatchActionAttributes, readClickAttributes } from "./utilty";

const toOptionalNumber = (value: string): number | undefined => {
  const trimmed = value.trim();
  if (!trimmed) return undefined;
  const parsed = Number(trimmed);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export const input = (el: ActionNode<HTMLInputElement>) => {
  const dispatchClickAction = () => {
    dispatchActionAttributes(el, readClickAttributes(el));
  };

  const dispatchDeltaFromValue = () => {
    const attr = readClickAttributes(el);
    if (!('type' in attr)) return;

    const delta = toOptionalNumber(el.value);
    if (delta === undefined) return;

    dispatchActionAttributes(el, {
      type      : attr.type,
      delta,
      min       : toOptionalNumber(el.min),
      max       : toOptionalNumber(el.max),
      useAsValue: true,
      storeId   : attr.storeId
    });
  };

  switch (el.type) {
    case "checkbox":
    case "radio":
      if (el.checked) {
        dispatchClickAction();
      }
      addEventListener(el, "click", dispatchClickAction);
      break;
    case "text":
    case "number":
      addEventListener(el, "change", dispatchDeltaFromValue);
      break;
  }
}
